module.exports = __webpack_public_path__ + "static/media/thumbnail.510b2f81.jpg";